import { RootState } from 'handlers';

export const getStudentLoanScheduleData = ({ studentLoanScheduleData }: RootState) => studentLoanScheduleData;
